/** @type {import("@chakra-ui/react").ComponentStyleConfig} */
export const BUTTON_THEME = {
  variants: {
    solid: {
      fontSize: "20px",
      fontWeight: 400,
    },
    outline: {
      fontSize: "20px",
      fontWeight: 400,
    },
  },
  baseStyle: {
    borderRadius: "2px",
    fontFamily: "'Lato', sans-serif",
    color: "red",
  },
};
